import React from "react";
import QrReader from "react-qr-reader";

export default function QRScanner({
  setQrResult,
  setIsScanned,
  isOpen,
  ignoredResult,
}) {
  /**
   * Handles the QR code scan event.
   * @param {String} data The scanned QR code
   */
  const handleScan = (data) => {
    if (data && data !== ignoredResult) {
      setQrResult(data);
      setIsScanned(true);
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  return (
    isOpen && (
      <QrReader
        // style={{
        //   height: "50%",
        //   width: "100%",
        // }}
        // containerStyle={{ height: "25%" }}
        className="qr-reader-section max-h-[60dvh] *:rounded-lg"
        videoStyle={{
          borderRadius: "0.75rem",
        }}
        showViewFinder
        onError={handleError}
        onScan={handleScan}
      />
    )
  );
}
